<template>
  <div style="background:#fff;height:100%"
       id="pendingOrders"
       v-loading="loading">
    <el-card class="box-card"
             style="width: 100%;padding-bottom: 0;padding-left:20px">
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="宣教名称">
          <el-input v-model="formInline.search"
                    style="width:180px"
                    placeholder="宣教名称"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      v-if="configType!='all'">
          <el-select v-model="formInline.status"
                     style="width:140px"
                     placeholder="状态">
            <el-option :label="i"
                       v-for="(i, index) in status_obj"
                       :key="index"
                       :value="index"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="onSubmit">查询</el-button>
          <el-button type="info"
                     @click="Reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="sec_card">
      <div class="flex">
        <div class="sectionfl"
             v-if="ashndklas">
          <h6>
            宣教分类
            <Button @click="append()"
                    type="text"
                    style="font-size: 26px; color:#A09999; float: right; ">+</Button>
          </h6>
          <div class="tip">
            <i class="el-icon-warning"
               style="margin-right:5px"></i>一级分类不可新建宣教，请先在对应业务下创建二级分类
          </div>
          <div style="flex:1;overflow: auto">
            <el-tree ref="viewTree"
                     :data="typeLists"
                     node-key="id"
                     :props="defaultProps"
                     :highlight-current="showTree"
                     @node-click="handleNodeClick"
                     :expand-on-click-node="false"
                     :default-expanded-keys="defaultExpanded"
                     :default-checked-keys="defaultChecked">
              <span class="custom-tree-node"
                    slot-scope="{ node, data }">
                <!-- <span>{{ node.name }}</span> -->
                <span>{{data.text}}</span>
                <i>
                  <el-popover placement="right-end"
                              width="40"
                              trigger="hover">
                    <div>
                      <div class="hovers"
                           v-if="data.level != '1'">
                        <el-button type="text"
                                   size="mini"
                                   style="color:#738299"
                                   @click.stop="() => modifyEdit(node,data)">
                          <i style="padding-right:6px"
                             class="el-icon-edit-outline"></i>编辑分类
                        </el-button>
                      </div>
                      <div class="hovers"
                           v-if="data.level != '1'">
                        <el-button type="text"
                                   style=" color: #738299"
                                   size="mini"
                                   @click.stop="() => remove( data)">
                          <i style="padding-right:6px"
                             class="el-icon-delete"></i>删除分类
                        </el-button>
                      </div>
                      <div class="hovers">
                        <el-button type="text"
                                   style=" color: #738299"
                                   size="mini"
                                   @click.stop="() => append( data)">
                          <i style="padding-right:6px"
                             class="el-icon-plus"></i>新增分类
                        </el-button>
                      </div>
                    </div>

                    <i slot="reference"
                       style="transform:rotate(90deg);color:#999"
                       class="el-icon-more"></i>
                    <!-- <i >激活</i> -->
                  </el-popover>
                </i>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="sectionfr">

          <div v-if="configType=='all'"
               style="margin-bottom: 10px ; text-align: right;">
            <Button type="primary"
                    shape="circle"
                    @click="addDropaganda()">新增宣教</Button>
            <Button type="primary"
                    shape="circle"
                    @click="copyKnowledge()"
                    style="margin-left:10px">从知识库新建</Button>
          </div>
          <Card style="position:relative;">
            <Table :columns="columns"
                   :data="list"
                   :loading="!haveData">
              <template slot-scope="{row, index}"
                        slot="action">
                <div>
                  <el-button type="text"
                             style="margin-right: 10px"
                             @click="editModule(row,index)">详情</el-button>
                  <el-button type="text"
                             v-if="configType=='all'"
                             style="margin-left: 0"
                             @click="removeQuesType(row)">删除</el-button>
                </div>
              </template>
              <template slot-scope="{row, index}"
                        slot="state">
                <div>
                  {{   status_obj[row.record_state]}}
                </div>
              </template>

            </Table>
          </Card>
          <Page :total="total"
                class="pageBox"
                @on-change="changeIndex"
                show-total />
        </div>
      </div>
    </el-card>
    <Modal v-model="dialogFormVisible"
           draggable
           footer-hide
           :title="fileNmae"
           :z-index="999">
      <div :style="{'max-height': (windowHeight - 100 * 2 - 150) + 'px'}">
        <Form ref="form"
              :model="form"
              :rules="formRules"
              :label-width="100">
          <FormItem label="分类名称"
                    prop="type_name">
            <Input v-model.trim="form.type_name"
                   :maxlength="10"
                   style="width:260px"
                   placeholder="请输入分类名称"></Input>
          </FormItem>
          <FormItem label="可见范围"
                    prop="type_name">
            <Select v-model="form.VisibleValue"
                    clearable
                    @on-change="setdiseaseList"
                    style="width:260px">
              <Option v-for="item in Visible"
                      :disabled="item.disabled"
                      :value="item.value"
                      :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="选择病种"
                    v-if="showDiseaseList"
                    prop="type_name">
            <Select v-model="form.iseaseList"
                    multiple
                    style="width:260px">
              <Option v-for="item in disease_tree_responses"
                      :value="item.disease_id"
                      :key="item.disease_id">{{ item.disease_name }}</Option>
            </Select>
          </FormItem>
        </Form>
        <div style="text-align:center;margin-top:16px;">
          <Button @click="cancel()">取消</Button>
          <Button type="primary"
                  style="margin-left:20px"
                  @click="submit()">保存</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="copyVisible"
           width="80%"
           footer-hide
           title
           :z-index="999">
      <div :style="{'max-height': (windowHeight - 100 * 2 ) + 'px'}"></div>
      <Tabs :value="tabValue"
            :animated="false"
            @on-click="onTabClick">
        <TabPane type="border-card"
                 v-for="(i, index) in queryList"
                 :key="'tab_' + index"
                 :label="i.name"
                 :name="i.name"></TabPane>
        <div style="position:relative;margin-top:16px;">
          <chooseArtical :style="{'max-height': (windowHeight - 100 * 3 ) + 'px'}"
                         style="overflow-y: auto;"
                         :info="hosInfo"
                         @selectionData="selectionData"></chooseArtical>
          <div style="text-align:center;margin-top:16px;">
            <Button @click="cancelModal()">取消</Button>
            <Button type="primary"
                    style="margin-left:20px"
                    @click="submitModal()">保存</Button>
          </div>
        </div>
      </Tabs>
    </Modal>
  </div>
</template>

<script>
import chooseArtical from '../common/chooseArtical'
import route from '../../route/config'
let qs = require('qs')
import {
  getTabs,
  copyArtical,
  apply_list_nom,
  apply_list_my_nom,
  APPLY_DETAIL_nom,
  APPLY_DELETE_nom,
} from '../../api/article'
export default {
  data() {
    return {
      formInline: {
        search: '',
        status: '5',
      },
      loading: false,
      fileNmae: '新增分类',
      typeLists: [],
      dialogFormVisible: false,
      typeNmae: '',
      typeCode: '',
      tabValue: '',
      form: {
        type_name: '',
        iseaseList: [],
        VisibleValue: '',
      },
      status_obj: {
        0: '待审批',
        1: '已发布',
        2: '已驳回',
        5: '全部',
      },
      Visible: [
        {
          value: '0',
          label: '个人可见',
          disabled: false,
        },
        {
          value: '1',
          label: '病种可见',
          disabled: false,
        },
      ],
      formRules: {
        type_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
        ],
        // name: [{ required: true, message: '请选择分类名称', trigger: 'blur' }],
      },
      columns: [],
      showTree: true,
      defaultProps: {
        children: 'children',
        label: 'text',
      },
      list: [],
      haveData: false,
      total: 0,
      current: 1,
      size: 10,
      sizes: [20, 30, 40, 50],
      quesInfo: {},
      index_page: 0,
      disease_tree_responses: [],
      showDiseaseList: false,
      SelectData: {},
      creatData: {},
      flag: false,
      copyVisible: false,
      ashndklas: true,
      defaultChecked: [],
      queryList: [],
      hosInfo: {},
      defaultExpanded: [],
      types: this.configType == 'all' ? apply_list_nom : apply_list_my_nom,
    }
  },
  props: {
    configType: {
      type: String | Number,
      default: '',
    },
  },
  components: {
    chooseArtical,
  },
  computed: {
    refreshQues: function () {
      return this.$store.state.refreshQues
    },
    windowHeight: function () {
      return window.innerHeight
    },
  },
  methods: {
    selectionData: function (data) {
      this.select = data
    },
    submitModal: function () {
      if (this.select.length == 0) {
        this.$Message.warning('请选择宣教')
        return
      }
      console.log(this.select)
      let artical_request_list = []
      this.select.forEach((v) => {
        let obj = {}
        obj.category_id = this.typeCode
        obj.news_id = v.news_id
        obj.title = v.news_name
        artical_request_list.push(obj)
      })
      console.log(artical_request_list)

      copyArtical(artical_request_list).then((res) => {
        if (res.code === 0) {
          this.copyVisible = false
          this.getQuesList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    copyKnowledge: function () {
      this.getTab()
      this.copyVisible = true
    },
    getTab: function () {
      getTabs({}).then((res) => {
        if (res.code === 0) {
          this.queryList = res.data
          if (res.data.length > 0) {
            this.tabValue = this.queryList[0].name
            this.onTabClick(res.data[0].name)
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    onTabClick: function (name) {
      console.log(name)
      this.tabValue = name
      this.queryList.forEach((v) => {
        if (v.name == name) {
          this.hosInfo = v
        }
      })
    },
    cancelModal: function () {
      this.copyVisible = false
    },
    Reset() {
      this.ashndklas = true
      this.formInline.search = ''
      this.formInline.status = '5'
      this.getQuesList()
    },
    onSubmit() {
      var self = this
      self.haveData = false
      // let shift = this.$store.state.shift
      let obj = {}

      if (this.configType == 'all') {
        obj = {
          title: this.formInline.search,
        }
      } else {
        obj = {
          status: this.formInline.status == 5 ? '' : this.formInline.status,
          title: this.formInline.search,
        }
      }

      this.types(obj).then((res) => {
        self.haveData = true
        this.ashndklas = false

        self.total = res.data.total || 0
        if (res.code === 0) {
          this.list = res.data.records
          // self.list = res.data
        } else {
          self.$Message.error(res.message)
        }
      })
    },

    changeIndex(e) {
      this.index_page = e
      this.getQuesList()
    },

    setdiseaseList(val) {
      if (val == 1 && this.disease_tree_responses.length != 0) {
        this.showDiseaseList = true
      } else {
        this.showDiseaseList = false
      }
    },
    handleNodeClick(data, e) {
      if (data.level == 1) {
        this.flag = false
      } else {
        this.flag = true
      }
      this.creatData = data
      this.typeCode = data.id
      this.getQuesList()
    },
    column: function (id, index) {
      this.index_page = index
      this.typeCode = id
      this.getQuesList()
    },
    cancel: function () {
      this.dialogFormVisible = false
      this.typeNmae = ''
      this.typeCode = ''
    },
    modifyEdit: function (node, data) {
      console.log(node, data)
      this.form.VisibleValue = ''
      this.disease_tree_responses = []
      let diseaseList = this.$store.getters.curDiseaseList
      if (node.parent.data.level == 1) {
        this.disease_tree_responses = diseaseList
      } else {
        this.disease_tree_responses = node.parent.data.disease_tree_responses
      }

      if (data.disease_tree_responses.length) {
        this.form.VisibleValue = '1'
        this.showDiseaseList = true
      } else {
        this.form.VisibleValue = '0'
        this.showDiseaseList = false
      }

      let arr = []
      data.disease_tree_responses.forEach((res) => {
        arr.push(res.disease_id)
      })
      this.form.iseaseList = arr
      this.dialogFormVisible = !this.dialogFormVisible
      this.form.type_name = data.text

      this.fileNmae = '编辑宣教分类'
      this.SelectData = data
    },

    append(data) {
      this.form.iseaseList = []
      let shift = this.$store.state.shift

      this.form.iseaseList.push(shift.disease_id)
      this.form.VisibleValue = ''
      this.form.type_name = ''

      if (data) {
        this.ResetList(data)
      }
      this.dialogFormVisible = !this.dialogFormVisible
      this.fileNmae = '新增宣教分类'

      this.SelectData = data
    },
    ResetList(data) {
      let diseaseList = this.$store.getters.curDiseaseList
      this.Visible[1].disabled = false
      if (data.level == 1) {
        if (
          data.disease_tree_responses == null ||
          data.disease_tree_responses.length == 0
        ) {
          this.disease_tree_responses = diseaseList
        } else {
          this.disease_tree_responses = data.disease_tree_responses
        }
      } else if (data.level != 1 && data.user_id != null) {
        this.disease_tree_responses = data.disease_tree_responses
      } else {
        this.disease_tree_responses = []
        this.Visible[1].disabled = true
      }
    },
    submit: function () {
      let url = this.$utils.getInterface('NEWS_CATEGORY'),
        query

      if (!this.form.type_name) {
        this.$Message.warning('填写分类名称')
        return
      }
      if (!this.form.VisibleValue) {
        this.$Message.warning('请选择可见范围')
        return
      }
      if (this.form.VisibleValue == '1') {
        if (!this.form.iseaseList.length) {
          this.$Message.warning('请选着病种')
          return
        }
      }

      if (this.form.VisibleValue == '0') {
        query = {
          disease_id: this.$store.state.shift.dept_id,
          category_name: this.form.type_name,
          level: this.SelectData.level + 1,
          parent_id: this.SelectData.id,
          permission_type: this.form.VisibleValue,
        }
      } else {
        query = {
          disease_id: this.$store.state.shift.dept_id,
          category_name: this.form.type_name,
          level: this.SelectData.level + 1,
          parent_id: this.SelectData.id,
          permission_type: this.form.VisibleValue,
          disease_ids: this.form.iseaseList,
        }
      }
      if (this.fileNmae == '编辑宣教分类') {
        url = this.$utils.getInterface('NEWS_CATEGORY') + '/edit'
        query.id = this.SelectData.id
      }

      //       url = this.$utils.getInterface('NEWS_CATEGORY')
      this.$utils.caringRequest({
        method: 'POST',
        url: url,
        data: query,
        success: (res) => {
          if (res.code == 0) {
            this.getTypeGroup()
            this.dialogFormVisible = !this.dialogFormVisible
            this.form.iseaseList = []
            this.form.VisibleValue = ''
            this.form.type_name = ''
          }
        },
      })
    },
    remove: function (data) {
      console.log(data)
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认删除该分类?',
        onOk: () => {
          self.fileNmae = '删除宣教分类'
          self.typeNmae = data.name
          self.typeCode = data.id
          self.form.type_name = data.name

          this.$utils.caringRequest({
            method: 'POST',
            url:
              this.$utils.getInterface('NEWS_CATEGORY') + '/remove/' + data.id,

            success: (res) => {
              if (res.code == 0) {
                this.getTypeGroup()
              } else {
                this.$Message.error(res.message)
              }
            },
          })
        },
      })
    },
    removeQuesType(row) {
      let self = this
      console.log(row)
      self.$Modal.confirm({
        title: '提示',
        content: '删除操作不可恢复，请谨慎操作！',
        onOk: () => {
          this.$utils.caringRequest({
            method: 'DELETE',
            url:
              this.$utils.getInterface('ADD_CATEGORY') +
              '/delete?news_id=' +
              row.news_id,
            success: (res) => {
              if (res.code == 0) {
                this.getQuesList()()
              } else {
                this.$Message.error(res.message)
              }
            },
          })
        },
      })
    },

    getTypeGroup: function () {
      let shift = this.$store.state.shift
      var self = this
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('NEWS_CATEGORY'),
        data: {
          disease_id: shift.disease_id,
          dept_id: shift.dept_id,
        },

        success: function (res) {
          if (res.code === 0) {
            self.haveData = true
            self.typeLists = res.data
            self.typeCode = res.data[0].id
            self.typeNmae = res.data[0].name
            self.index_page = 0
            self.creatData = res.data[0]
            self.getQuesList()
            self.handleNodeClick(res.data[0].children[0])
            self.defaultExpanded.push(res.data[0].id)
            self.defaultChecked.push(res.data[0].children[0].id)
            self.$nextTick(function () {
              self.$refs.viewTree.setCurrentKey(res.data[0].children[0].id)
            })
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    refesh() {
      const list = this.$store.state.allSelectedKeys.map((l) => {
        if (l.key === 'newsAdd') {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.$store.state.allSelectedKeys.map((l) => {
          if (l.key === 'newsAdd') {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    editModule: function (row) {
      //
      let self = this
      self.loading = true
      let query = {
        news_id: row.news_id,
        flag: this.configType == 'all' ? 1 : 0,
      }
      APPLY_DETAIL_nom(query).then((res) => {
        self.refesh()
        self.loading = false
        console.log(8908, res.data)
        self.$store.commit('setPropaganda', res.data)
        self.creatData.flag = this.configType == 'all' ? 1 : 0
        self.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'newsAdd',
          title: '发布文章',
          key: 'newsAdd',
          extra: {
            creatData: self.creatData,
          },
        })
      })
      // self.$utils.caringRequest({
      //   method: 'GET',
      //   url:
      //     this.$utils.getInterface('APPLY_DETAIL') +
      //     '/id?news_id=' +
      //     row.news_id,

      //   success: function (res) {

      //   },
      // })
    },
    getQuesList: function () {
      var self = this
      self.haveData = false
      let obj = {
        category_id: self.typeCode,
        page: self.index_page,
        size: 10,
      }
      this.types(obj).then((res) => {
        self.haveData = true
        self.total = res.data.total || 0

        if (res.code === 0) {
          console.log(99, res.data)
          this.list = res.data.records

          // self.list = res.data
        } else {
          self.$Message.error(res.message)
        }
      })
    },
    addDropaganda: function () {
      let self = this
      self.refesh()
      self.$store.commit('setPropaganda', '')
      self.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'newsAdd',
        title: '发布文章',
        key: 'newsAdd',
        extra: {
          creatData: self.creatData,
        },
      })
    },
    moveToDetail(row) {},
    compare: function (realIndex) {
      return function (obj1, obj2) {
        var value1 = obj1[realIndex]
        var value2 = obj2[realIndex]
        return value1 - value2
      }
    },
    analysis: function (row) {
      console.log(row)
      let group = []
      group[0] = row.type_id
      group[1] = row.id
      this.$store.commit('setGroupId', group)

      // this.$utils.openPage({
      //   type: 'filterAnalysis',
      //   title: '筛查分析',
      //   id: 0,
      //   params: {
      //     id: row.questionnaire_id,
      //   },
      // })
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'filterAnalysis',
        title: route['filterAnalysis'].title,
        key: `filterAnalysis?${row.questionnaire_id}`,
        extra: {
          id: row.questionnaire_id,
        },
      })
    },
  },
  mounted() {
    if (this.configType == 'all') {
      this.columns = [
        {
          title: '宣教名称',
          key: 'news_name',
          align: 'center',
        },

        {
          title: '创建时间',
          key: 'create_time',
          align: 'center',
        },

        {
          title: '操作',
          key: 'action',
          minWidth: 60,
          slot: 'action',
          align: 'center',
        },
      ]
    } else {
      this.columns = [
        {
          title: '宣教名称',
          key: 'news_name',
          align: 'center',
        },
        {
          title: '创建时间',
          key: 'create_time',
          align: 'center',
        },
        {
          title: '状态',
          key: 'record_state',
          align: 'center',
          slot: 'state',
        },
        {
          title: '操作',
          key: 'action',
          minWidth: 60,
          slot: 'action',
          align: 'center',
        },
      ]
    }
    //     console.log()
    this.getTypeGroup()
  },
  watch: {
    refreshQues: function () {
      this.getQuesList()
    },
  },
}
</script>

<style lang="less" >
</style>
